import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import type { ContentTable } from 'pdfmake/interfaces';
import type { GetStandardFormFieldLabel } from 'src/hooks/forms/useFormCustomisation';

import { useLazyGetObligationImpactsByParentId } from '@/hooks/queries';
import { createTable, tableHeaders } from '@/utils/pdf/table';

const useImpactsExportTable = (
  obligationId: string,
  getStandardFieldLabel: GetStandardFormFieldLabel
): [() => Promise<ContentTable>, boolean] => {
  const { getLabel: getImpactLabel } = useRating('impact');
  const [getImpacts, getImpactsResult] =
    useLazyGetObligationImpactsByParentId();

  const createExportTable = async () => {
    const { data: impactData } = await getImpacts({
      parentId: obligationId,
    });
    const issuesTableData = (impactData?.obligation_impact ?? []).map((i) => [
      i.Description,
      getImpactLabel(i.ImpactRating),
    ]);

    return createTable({
      widths: '*',
      body: [
        tableHeaders([
          getStandardFieldLabel('obligation_impact', 'Description'),
          getStandardFieldLabel('obligation_impact', 'ImpactRating'),
        ]),
        ...issuesTableData,
      ],
    });
  };

  return [createExportTable, getImpactsResult.loading];
};

export default useImpactsExportTable;
